export const FETCH_DASHBOARD_DATA_REQUEST = "FETCH_DASHBOARD_DATA_REQUEST";
export const FETCH_DASHBOARD_DATA_SUCCESS = "FETCH_DASHBOARD_DATA_SUCCESS";
export const FETCH_DASHBOARD_DATA_FAILURE = "FETCH_DASHBOARD_DATA_FAILURE";

export const FETCH_VENDOR_DASHBOARD_DATA_REQUEST =
  "FETCH_VENDOR_DASHBOARD_DATA_REQUEST";
export const FETCH_VENDOR_DASHBOARD_DATA_SUCCESS =
  "FETCH_VENDOR_DASHBOARD_DATA_SUCCESS";
export const FETCH_VENDOR_DASHBOARD_DATA_FAILURE =
  "FETCH_VENDOR_DASHBOARD_DATA_FAILURE";

export const FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST =
  "FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST";
export const FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS =
  "FETCH_CUSTOMER_DASHBOARD_DATA_SUCCESS";
export const FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE =
  "FETCH_CUSTOMER_DASHBOARD_DATA_FAILURE";
